/**
 * Context Packs API service
 */

import apiClient, { ApiResponse } from './client';

export interface ContextPack {
  id: string;
  organization_id: string;
  name: string;
  context_text: string | null;
  prefill_name: string | null;
  prefill_email: string | null;
  prefill_phone: string | null;
  share_title: string | null;
  share_description: string | null;
  share_thumbnail_url: string | null;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface ContextPackCreate {
  name: string;
  context_text?: string | null;
  prefill_name?: string | null;
  prefill_email?: string | null;
  prefill_phone?: string | null;
  share_title?: string | null;
  share_description?: string | null;
  share_thumbnail_url?: string | null;
  is_active?: boolean;
}

export interface ContextPackUpdate {
  name?: string;
  context_text?: string | null;
  prefill_name?: string | null;
  prefill_email?: string | null;
  prefill_phone?: string | null;
  share_title?: string | null;
  share_description?: string | null;
  share_thumbnail_url?: string | null;
  is_active?: boolean;
}

class ContextPacksService {
  async list(organizationId: string): Promise<ApiResponse<ContextPack[]>> {
    return apiClient.get<ContextPack[]>(
      `/api/organizations/${organizationId}/context-packs`,
    );
  }

  async get(organizationId: string, packId: string): Promise<ApiResponse<ContextPack>> {
    return apiClient.get<ContextPack>(
      `/api/organizations/${organizationId}/context-packs/${packId}`,
    );
  }

  async create(
    organizationId: string,
    data: ContextPackCreate,
  ): Promise<ApiResponse<ContextPack>> {
    return apiClient.post<ContextPack>(
      `/api/organizations/${organizationId}/context-packs`,
      data,
    );
  }

  async update(
    organizationId: string,
    packId: string,
    data: ContextPackUpdate,
  ): Promise<ApiResponse<ContextPack>> {
    return apiClient.put<ContextPack>(
      `/api/organizations/${organizationId}/context-packs/${packId}`,
      data,
    );
  }

  async remove(organizationId: string, packId: string): Promise<ApiResponse<void>> {
    return apiClient.delete(`/api/organizations/${organizationId}/context-packs/${packId}`);
  }
}

const contextPacksService = new ContextPacksService();
export default contextPacksService;
